// Home — market index dashboard som visar 5 mini-charts (DOW, NASDAQ,
// S&P 500, RUSSELL 2000, VIX). Data uppdateras hourly via backend.

import { Link } from 'react-router-dom';
import IndexMiniChart from '../components/dashboard/IndexMiniChart';

interface Index {
  ticker: string;
  name: string;
  displayName: string;
}

const INDICES: Index[] = [
  { ticker: '^DJI', name: 'Dow Jones Industrial Average', displayName: 'DOW' },
  { ticker: '^IXIC', name: 'NASDAQ Composite', displayName: 'NASDAQ' },
  { ticker: '^GSPC', name: 'S&P 500', displayName: 'S&P 500' },
  { ticker: '^RUT', name: 'Russell 2000', displayName: 'RUSSELL 2000' },
];

const VIX: Index = {
  ticker: '^VIX',
  name: 'CBOE Volatility Index',
  displayName: 'VIX',
};

export default function Home() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white">
          Investen
        </h1>
        <p className="mt-2 text-slate-600 dark:text-slate-400">
          Market Overview · Uppdateras varje timme
        </p>
      </div>

      {/* 4 index grid */}
      <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {INDICES.map((idx) => (
          <IndexMiniChart
            key={idx.ticker}
            ticker={idx.ticker}
            name={idx.name}
            displayName={idx.displayName}
          />
        ))}
      </div>

      {/* VIX (wider card) */}
      <div className="mb-8">
        <IndexMiniChart
          ticker={VIX.ticker}
          name={VIX.name}
          displayName={VIX.displayName}
          variant="wide"
        />
      </div>

      {/* Quick links */}
      <div className="rounded border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900">
        <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-600 dark:text-slate-400">
          Verktyg
        </h2>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/screener"
            className="rounded bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
          >
            Screener
          </Link>
          <Link
            to="/watchlist"
            className="rounded border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            Watchlist
          </Link>
        </div>
      </div>
    </div>
  );
}
